import React, { useState } from "react";
import "./Accordion.scss";

const Accordion = ({ children, label }) => {
  const [open, setopen] = useState(false);

  const toggle = () => {
    setopen((state) => !state);
  };

  return (
    <div className={"accordion" + (open ? " open" : "")} onClick={toggle}>
      <div className="accordion__label">{label}</div>
      <div className="accordion__content">{children}</div>
    </div>
  );
};

export default Accordion;
